import React, {useState, useEffect} from "react";
import {useApplicationContext} from '../../../provider'
import {getContent} from '../../../react-hooks/useContentCompiler'
import { initHeader, clearHeader } from "../utils";

export default function Header ({ context }) {


  const { handleBarCompiler } = useApplicationContext()
  const [content, setContent] = useState('')
  const rawTemplate = require(`raw-loader!../../../compiled/braintree/templates/partials/header.hbs`)
  useEffect(()=>{
    setContent(getContent(rawTemplate, handleBarCompiler, context))
  },[context])

  useEffect(() => {
    if(content){
      window.BTBaseLib.initializeSearchComponent(context)
      initHeader() 
      return () => clearHeader()
    }
  },[content])
  
  return (
    <>
      <div dangerouslySetInnerHTML={{__html: content}} />
    </>
  );
};
